import { render, staticRenderFns } from "./BookMetaTabs.vue?vue&type=template&id=5f1ae61d"
import script from "./BookMetaTabs.vue?vue&type=script&lang=js"
export * from "./BookMetaTabs.vue?vue&type=script&lang=js"
import style0 from "./BookMetaTabs.vue?vue&type=style&index=0&id=5f1ae61d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports